function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useTranslation } from 'next-i18next';
import { Chip } from '@dentalux/ui-library-core/components/chip';
import { RecommendationSpecialityAggregation } from 'src/@types/Recommendation';
import { DialogNames } from 'src/components/dialogs/DialogRoot';
import RecommendationTick from 'src/components/icons/RecommendationTick';
import { useDialog } from 'src/components/providers/DialogProvider';
import { setActive, useRecommendation, useRecommendationDispatch } from 'src/components/providers/RecommendationProvider';
import { SwipeStack } from 'src/components/SwipeStack/Book';
import { DataTestIds } from 'src/config/dataTestIds';
import useElementSize from 'src/hooks/useElementSize';
import useIsMobile from 'src/hooks/useIsMobile';
import { Recommendation } from '../Recommendation/Recommendation';
import Section from '../Section';
import * as S from './RecommendationSection.styles';
const dataTestIdMapping = {
  [RecommendationSpecialityAggregation.Dental]: DataTestIds.DentalMedicineRecommendationsButton,
  [RecommendationSpecialityAggregation.Other]: DataTestIds.HumanMedicineRecommendationsButton
};
export const RecommendationSection = ({
  processing,
  recommendations
}) => {
  const {
    t
  } = useTranslation();
  const [cardRef, {
    width
  }] = useElementSize();
  const isMobile = useIsMobile();
  const {
    active,
    entries
  } = useRecommendation({
    recommendations
  });
  const dispatch = useRecommendationDispatch();
  const prepareChip = speciality => ({
    icon: active === speciality ? /*#__PURE__*/React.createElement(RecommendationTick, null) : undefined,
    variant: speciality === active ? 'filled' : 'bordered',
    onClick: () => dispatch(setActive(speciality)),
    disabled: !recommendations[speciality === RecommendationSpecialityAggregation.Dental ? 'dental' : 'other'].length,
    ['data-testid']: dataTestIdMapping[speciality]
  });
  const {
    openDialog
  } = useDialog();
  const getCount = count => {
    if (count > 1) {
      return ` (${count})`;
    }
    return '';
  };
  return /*#__PURE__*/React.createElement(Section, {
    title: t('b2c.home.subheading.recommendation'),
    show: !processing && (recommendations.dental.length > 0 || recommendations.other.length > 0)
  }, /*#__PURE__*/React.createElement(S.Chips, null, /*#__PURE__*/React.createElement(S.DentalChips, _extends({
    label: `${t('b2c.recommendations.kind.dental')}${getCount(recommendations.dental.length)}`
  }, prepareChip(RecommendationSpecialityAggregation.Dental))), /*#__PURE__*/React.createElement(Chip, _extends({
    label: `${t('b2c.recommendations.kind.human')}${getCount(recommendations.other.length)}`
  }, prepareChip(RecommendationSpecialityAggregation.Other)))), /*#__PURE__*/React.createElement(SwipeStack, {
    direction: isMobile ? 'row' : 'column',
    ref: cardRef
  }, entries.map(recommendation => /*#__PURE__*/React.createElement(Recommendation, {
    onClose: e => {
      e.stopPropagation();
      openDialog(DialogNames.IgnoreRecommendation, {
        referenceId: recommendation.referenceId
      });
    },
    key: recommendation.referenceId,
    data: recommendation,
    width: width
  }))));
};